import { fmtNum } from '../../utils/format';

export default function EodSpotTable({ rows }) {
  return (
    <div className="oc-r" id="ocResSup">
      <table className="rt">
        <thead>
          <tr><th>DATE</th><th>RES</th><th>SPOT</th><th>SUP</th><th>MP</th><th>PCR</th></tr>
        </thead>
        <tbody>
          {!rows?.length ? (
            <tr><td colSpan={6} style={{ padding: 12, color: 'var(--text-dim)' }}>No spot/level rows for this selection.</td></tr>
          ) : rows.map((r, i) => (
            <tr key={i}>
              <td>{r.date}</td>
              <td className="rr">{r.resistance ? fmtNum(r.resistance, 0) : '—'}</td>
              <td>{r.spot ? fmtNum(r.spot) : '—'}</td>
              <td className="rs">{r.support ? fmtNum(r.support, 0) : '—'}</td>
              <td>{r.maxPain ? fmtNum(r.maxPain, 0) : '—'}</td>
              <td>{r.pcr ? Number(r.pcr).toFixed(2) : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}